import * as React from "react";
import { Table, Button } from "react-bootstrap";
import { firestore } from "firebase";
import * as fs from "../firestore";
import moment from "moment";
import { Icon } from "semantic-ui-react";
import { soilTypeIndexLabelMap, deleteFlagLabelMap } from "../ResultsTableLabel";

export type SamplingResult = fs.SamplingResult & {id: string, userName: string};

interface Props {
    samplingResults: SamplingResult[];
    showDeleteFlag: boolean;
    onRequestShowAnalysisResults: (samplingResultId: string) => void;
    onImageLinkClicked: (samplingId: string, filename: string) => void;
}

export default class SamplingResultsTable extends React.Component<Props, {}> {

    formatTimestamp(timestamp: firestore.Timestamp): string {
        return moment(timestamp.toDate()).format("YYYY年MM月DD日 HH:mm:ss");
    }

    render() {
        return (
            <div style={{overflowX: "auto"}}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>分析結果</th>
                            {this.props.showDeleteFlag &&
                                <th>サンプルデータID</th>
                            }
                            {this.props.showDeleteFlag &&
                                <th>ユーザID</th>
                            }
                            <th>利用者名</th>
                            <th>土壌No.</th>
                            <th>採取日時</th>
                            <th>採取場所緯度</th>
                            <th>採取場所経度</th>
                            <th>画像ファイル名</th>
                            <th>コメント</th>
                            <th>圃場名</th>
                            <th>作物名</th>
                            <th>土質ID</th>
                            <th>作成日時</th>
                            <th>更新日時</th>
                            {this.props.showDeleteFlag &&
                                <th>削除フラグ</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.samplingResults.map((result, index) => {
                            return (
                                <tr key={index}>
                                    <td align="center">
                                        <Button onClick={() => this.props.onRequestShowAnalysisResults(result.id)}>
                                            {"分析データを表示"}
                                        </Button>
                                    </td>
                                    {this.props.showDeleteFlag &&
                                        <td>{result.id}</td>
                                    }
                                    {this.props.showDeleteFlag &&
                                        <td>{result.userRef.id}</td>
                                    }
                                    <td>{result.userName}</td>
                                    <td>{result.samplingNo}</td>
                                    <td>{this.formatTimestamp(result.samplingDateTime)}</td>
                                    <td>{result.samplingLatitude}</td>
                                    <td>{result.samplingLongitude}</td>
                                    <td>{result.samplingImage !== "" && result.samplingImage.split(",").map((filename, i) => {
                                            return (
                                                <span key={i}><a href="#" onClick={() => {this.props.onImageLinkClicked(result.id, filename)}}>{filename}</a> </span>
                                            );
                                    })}</td>
                                    <td>{result.comment}</td>
                                    <td>{result.fieldName}</td>
                                    <td>{result.cropName}</td>
                                    <td>{soilTypeIndexLabelMap[result.soilTypeIndex]}</td>
                                    <td>{this.formatTimestamp(result.createDateTime)}</td>
                                    <td>{this.formatTimestamp(result.updateDateTime)}</td>
                                    {this.props.showDeleteFlag &&
                                        <td>{deleteFlagLabelMap[result.deleteFlag ? "true" : "false"]}</td>
                                    }
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
